


















































































































































































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { Pane, Splitpanes } from 'splitpanes'
import TicketingTextEditor from '@/components/ticketing/TicketingTextEditor.vue'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import CreateProjectAddressSearch from '@/components/project/CreateProjectAddressSearch.vue'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import moment from 'moment'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import NumberField from '@/components/NumberField.vue'

interface ComponentData {
  loadingSave: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  splitHeight: string
  pane1Size: number
  pane2Size: number
  pane2Height: number
  isSplitterOpen: boolean
  activeTab: number
  showAddressSearchDialog: boolean

  formIsValid: boolean
  type: string | null
  number: string | null
  description: string | null

  menu1: boolean
  atDate: string
  atDateFormatted: string
  menu2: boolean
  completedAtDate: string
  completedAtDateFormatted: string
  menu3: boolean
  planningDate: string
  planningDateFormatted: string
  dateRules: any[]
  addressId: number | null
  address: string | null
  externalAddressId: number | null
  externalAddress: string | null
  budget: number | null
}

export default Vue.extend({
  name: 'TicketingRequest',

  components: {
    Splitpanes,
    Pane,
    TicketingTextEditor,
    CreateProjectAddressSearch,
    NumberField
  },

  props: {
    isCreateTicket: Boolean,
    isEditTicket: Boolean,
    ticketDetail: Object as () => any
},

  data (): ComponentData {
    return {
      loadingSave: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      splitHeight: 'height: 695px',
      pane1Size: 100,
      pane2Size: 0,
      pane2Height: 200,
      isSplitterOpen: false,
      activeTab: 0,
      showAddressSearchDialog: false,

      formIsValid: false,
      type: null,
      number: null,
      description: null,

      menu1: false,
      atDate: '',
      atDateFormatted: '',
      menu2: false,
      completedAtDate: '',
      completedAtDateFormatted: '',
      menu3: false,
      planningDate: '',
      planningDateFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],
      addressId: null,
      address: null,
      externalAddressId: null,
      externalAddress: null,
      budget: null
    }
  },

  watch: {
    isCreateTicket (newVal: boolean): void {
      if(newVal) {
        this.setData()
        const form: any = this.$refs['form']
        form.resetValidation()
      } else {
        this.setData(this.ticketDetail)
        const form: any = this.$refs['form']
        form.resetValidation()
      }
    },

    ticketDetail (newVal: any): void {
      if(newVal) {
        this.setData(newVal)
      }
    },

    isEditMode (newVal: boolean): void {
      if(newVal) {
        this.onResize()
      } else {
        this.onResize()
      }
    },

    atDateFormatted (newVal: string): void {
      if(newVal) {
        this.atDate = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.atDate = ''
      }
    },

    completedAtDateFormatted (newVal: string): void {
      if(newVal) {
        this.completedAtDate = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.completedAtDate = ''
      }
    },

    planningDateFormatted (newVal: string): void {
      if(newVal) {
        this.planningDate = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.planningDate = ''
      }
    },
  },

  computed: {
    getLogo (): string {
      return require('@/assets/pin_green.png')
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEditMode (): boolean {
      if(this.isCreateTicket || this.isEditTicket) {
        setTimeout(() => {
          const focusedField: any = this.$refs['focusedField']
          if (focusedField) {
            focusedField.focus()
          }
        }, 0)
      }
      return this.isCreateTicket || this.isEditTicket
    },
  },

  methods: {
    onAtDateChange (date: string): void {
      this.atDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurAt (): void {
      this.atDateFormatted = moment(this.atDate).isValid() ? moment(this.atDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onCompletedAtDateChange (date: string): void {
      this.completedAtDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurCompletedAt (): void {
      this.completedAtDateFormatted = moment(this.completedAtDate).isValid() ? moment(this.completedAtDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onPlanningDateChange (date: string): void {
      this.planningDateFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurPlanning (): void {
      this.planningDateFormatted = moment(this.planningDate).isValid() ? moment(this.planningDate).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu3) {
          this.menu3 = false
        }
      }, 100)
    },

    onSearchAddressClick (): void {
      this.showAddressSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showAddressSearchDialog = false
    },

    onSelectedAddress (data: SearchAddress): void {
      this.closeSearchDialog()
      this.address = data.genAdresse
      this.addressId = data.id
    },

    selectedAddressEmployee (data: SearchAddressEmployee): void {
      this.closeSearchDialog()
      this.address = data.genAdresse
      this.addressId = data.adressID
    },

    onBudgetChange (): void {
      if(this.budget && this.budget < 0) {
        this.budget = null
      }
    },

    onSaveClick (): void {

    },

    onCancelClick (): void {
      this.setData(this.ticketDetail)
      this.$emit('onCancelRequestClick')
    },

    setData (data?: any): void {

    },

    splitterDoubleClick (e: any): void {
      if(this.isSplitterOpen) {
        setTimeout(() => {
          const vh = window.innerHeight
          const height = 160
          if(this.isEditMode) {
            this.pane1Size = (100 * 522) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          } else {
            this.pane1Size = (100 * 508) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          }
        }, 0)
      } else {
        setTimeout(() => {
          this.pane1Size = 0
          this.pane2Size = 100
          this.resizedSplitter(null)
        }, 0)
      }

      this.isSplitterOpen = !this.isSplitterOpen
    },

    resizedSplitter (item: any): void {
      setTimeout(() => {
        const pane2: any = this.$refs['pane2']
        this.pane2Height = pane2.$el.clientHeight - 58
      }, 300)
    },

    onResize (): void {
      const vh = window.innerHeight
      if(vh > 695) {
        const height = 160
        if((vh - height) > 200) {
          this.splitHeight = `height: calc(${vh}px - ${height}px)`
          if(this.isEditMode) {
            this.pane1Size = (100 * 522) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          } else {
            this.pane1Size = (100 * 508) / (vh - height)
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          }
        } else {
          this.splitHeight = 'height: 695px'
          if(this.isEditMode) {
            this.pane1Size = (100 * 522) / 695
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          } else {
            this.pane1Size = (100 * 508) / 695
            this.pane2Size = 100 - this.pane1Size
            this.resizedSplitter(null)
          }
        }
      } else {
        this.splitHeight = 'height: 695px'
        if(this.isEditMode) {
          this.pane1Size = (100 * 522) / 695
          this.pane2Size = 100 - this.pane1Size
          this.resizedSplitter(null)
        } else {
          this.pane1Size = (100 * 508) / 695
          this.pane2Size = 100 - this.pane1Size
          this.resizedSplitter(null)
        }
      }
    }
  },

  mounted () {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter!.addEventListener("dblclick", this.splitterDoubleClick)
    }

    this.setData(this.ticketDetail)
  },

  beforeDestroy() {
    const splitter = document.getElementsByClassName("splitpanes__splitter")[0]
    if(splitter) {
      splitter.removeEventListener("dblclick", this.splitterDoubleClick)
    }
  }
})
